module.exports = __webpack_public_path__ + "static/media/aftercare@2x.bdbbd003.jpg";